<div id="support-topic-block" class="main-content feature container-fluid">
  <form name="featureForm" #featureForm="ngForm" (ngSubmit)="featureForm.form.valid && onSave(featureForm)" novalidate>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 ">
        <div class="row step-title">
          <label class=" col-md-8  page-title">{{pageTitle}}</label>
          <div class="col-md-4 dashboard-action">
            <button class="btn btn-browse mr-2" *ngIf="isViewMode" type="button" (click)="openDashBorad();">
              Dashboard
            </button>
            <button class="btn btn-default" *ngIf="isViewMode && featureInfo.status == 'draft'" type="button" (click)="addStepFromFeature()">
              Add Step
            </button>
          </div>
        </div>

        <div class="feature-block base-container">
          <div class="row" *ngIf="!isAddMode">

            <div class="col-md-12 user-details mb-10" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">

              <label class="col-md-4">Created By: {{featureInfo.createdBy}}</label>

              <label class="col-md-4">Last Modified By: {{featureInfo.lastModifiedBy}}</label>

              <label class="col-md-4">Last Modified Date: {{ dateInfo }}</label>

            </div>

          </div>
          <div class="row" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
            <div class="col-md-12">
              <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                  <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                  {{ alert.msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <div *ngIf="isAddMode" class="row col-md-12 pl-0" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
                <mat-radio-group class="tp-radio-group" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedFeatureCreationType" (change)="featureCreationTypeChange($event)">
                  <mat-radio-button class="tp-radio-button" *ngFor="let type of featureCreationType" [value]="type">
                    {{type}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

          </div>

          <div class="row" *ngIf="selectedFeatureCreationType==='New'">
            <div class="col-md-5" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
              <mat-form-field class="example-full-width">
                <input [disabled]="isViewMode" matInput placeholder="Support Topic Name" required name="controlName" [(ngModel)]="featureInfo.controls[0].featureName"
                  value="" #featureName="ngModel">
              </mat-form-field>
              <mat-error *ngIf="featureForm.submitted && featureName.invalid">
                <div *ngIf="featureName.errors.required">Support Topic Name is required</div>
              </mat-error>
            </div>

            <div class="col-md-5" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
              <mat-form-field class="example-full-width">
                <input [disabled]="isViewMode" matInput placeholder="Display Name" required name="displayName" [(ngModel)]="featureInfo.controls[0].controlName"
                  value="" #displayName="ngModel">
              </mat-form-field>
              <mat-error *ngIf="featureForm.submitted && displayName.invalid">
                <div *ngIf="displayName.errors.required">Display Name is required</div>
              </mat-error>
            </div>


          </div>
          <div class="row">
            <mat-card class="col-10 pl-0">
              <div class="col-12" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
                <div>
                  <mat-radio-group aria-label="Content Type" [disabled]="isViewMode" [(ngModel)]="featureInfo.featureType" name="featureType"
                    required #contentType="ngModel" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">Content Type
                    <mat-radio-button value="internal">Internal</mat-radio-button>
                    <mat-radio-button value="external">External</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <mat-error *ngIf="featureForm.submitted && contentType.invalid">
                    <div *ngIf="contentType.errors.required">Content type is required</div>
                  </mat-error>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="row" *ngIf="selectedFeatureCreationType && selectedFeatureCreationType === 'New'">
            <mat-card class="col-10 pl-0">
              <div class="col-12" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
                <div>
                  <mat-label>Category :</mat-label>
                  <mat-button-toggle-group class="toggle-group" #category="ngModel" [disabled]="isViewMode" [(ngModel)]="featureInfo.category"
                    name="category">
                    <mat-button-toggle *ngFor="let obj of categoryList" [value]="obj.value">{{obj.name}}</mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <div>
                  <mat-error *ngIf="featureForm.submitted && category.invalid">
                    <div *ngIf="category.errors.required">Category is required</div>
                  </mat-error>
                </div>
              </div>
            </mat-card>
          </div>
          <div bgcolor="red" class="row" *ngIf="selectedFeatureCreationType==='New'">
            <div class="row col-12 mt-4" [ngStyle]="{'opacity': isViewMode? '0.7':'1'}">

              <mat-checkbox class="col-6" [checked]="featureInfo.isGeneric" [disabled]="isViewMode" (change)="updateGeneric($event)" name="generic"
                [(ngModel)]="featureInfo.isGeneric" labelPosition="before">{{ "Label.non_veh_capability" | translate}}
              </mat-checkbox>

              <mat-checkbox class="col-6" [checked]="featureInfo.hideProgressBar" [disabled]="isViewMode" (change)="enbleProgressBarDetail($event)"
                name="notes" [(ngModel)]="featureInfo.hideProgressBar" labelPosition="before">{{ "Label.progress_bar" | translate}}
              </mat-checkbox>

            </div>
            <div class="row col-12 mt-4" style="padding-left:30px;">

              <div class="col-md-5">
                <div>
                  <mat-radio-group aria-label="Content Type" (change)="onImageOptionChange($event)" [disabled]="isViewMode" [(ngModel)]="imageOptionType"
                    name="imageOptionType" #contentTypeText="ngModel">
                    <mat-radio-button value="addImages">Add Icon</mat-radio-button>
                    <mat-radio-button value="selectImages">Select Icon from S3</mat-radio-button>
                  </mat-radio-group>
                </div>

                <input #imageUploader type="file" hidden name="avatar" (click)="imageUploader.value = null" (change)="onFileChange($event.target.files,'')"
                />
                <button [hidden]="imageOptionType === 'addImages'" type="button" [disabled]="isViewMode" class="btn btn-browse" (click)="openS3ImageDialog();">{{ "Button.add_icon_s3" | translate}}</button>
                <button [hidden]="imageOptionType === 'selectImages'" type="button" [disabled]="isViewMode" class="btn btn-browse" (click)="iconUploader.click()">
                  {{ "Button.add_icon" | translate}}</button>
              </div>
              <div [ngStyle]="{'opacity': isViewMode? '0.7':'1'}">
                <input #iconUploader type="file" (click)="iconUploader.value = null" hidden name="avatar" [disabled]="isViewMode" (change)="onFileChange($event.target.files,'image')"
                />
              </div>
              <div class="col-7" [ngStyle]="{'opacity': isViewMode? '0.7':'1'}">
                <div *ngFor="let control of featureInfo.controls">
                  <div class="control-list" *ngIf="control.icon">
                    <span class="feature-icon-span image-thumbnail">
                      <img alt="app-thumbnill" class="thumbnail" [src]="thumbnilPath+control.icon" />
                    </span>
                    <span class="ellipsis" [hidden]="isImageFromS3" [matTooltip]="findIconName(control.icon)" matTooltipPosition="below" matTooltipClass="tooltip-class">{{imageName}}</span>
                    <span class="ellipsis" [hidden]="!isImageFromS3" [matTooltip]="findIconName(control.icon)" matTooltipPosition="below" matTooltipClass="tooltip-class">{{control.icon}}</span>

                    <span class="action-controls float-right">
                      <button [disabled]="isViewMode" class="ml-2 action-btn" type="button" (click)="openDeleteIconDialog(control.icon);">
                        <img alt="Delete" class="action-icon" [src]="commonService.commonFiles['delete']">
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <br>
          <div>
            <div class="col-md-12" *ngIf="isModelSelected && selectedFeatureCreationType !=='Copy From Existing'">
              <table aria-labelledby="Feature" aria-describedby="Feature" mat-table [dataSource]="documentsDataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="name">
                  <th id="vehicle-name" class="vehicle-header-card" mat-header-cell *matHeaderCellDef>Model</th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>
                <ng-container matColumnDef="year">
                  <th id="vehicle-year" class="vehicle-header-card" mat-header-cell *matHeaderCellDef> Year</th>
                  <td mat-cell *matCellDef="let element"> {{element.year}} </td>
                </ng-container>
                <ng-container matColumnDef="generation">
                  <th id="vehicle-generation" class="vehicle-header-card" mat-header-cell *matHeaderCellDef> Generation</th>
                  <td mat-cell *matCellDef="let element"> {{element.generation}} </td>
                </ng-container>
                <ng-container matColumnDef="classification">
                  <th id="vehicle-classification" class="vehicle-header-card" mat-header-cell *matHeaderCellDef> Classification</th>
                  <td mat-cell *matCellDef="let element"> {{element.classification}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <mat-paginator [pageSizeOptions]="[5,10]" showFirstLastButtons></mat-paginator>
            </div>
          </div>

          <div *ngIf="isAddMode && selectedFeatureCreationType ==='Copy From Existing'">
            <div class="row" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
              <div class="col-md-3">
                <mat-form-field [ngStyle]="{'margin-bottom': featureTypeSelect.invalid  && (featureTypeSelect.touched || this.isCopyClicked) ? '-0.8em':'0em'}">
                  <mat-label>Support Topic Type</mat-label>
                  <mat-select name="selectedFeatureType" (selectionChange)="supportTopicTypeChange($event);" required #featureTypeSelect="ngModel"
                    [(ngModel)]="selectedFeatureType">
                    <mat-option value='internal'>Internal</mat-option>
                    <mat-option value='external'>External</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="featureTypeSelect.invalid  && (featureTypeSelect.touched || this.isCopyClicked)">
                  <div *ngIf="featureTypeSelect.errors.required">Support Topic Type is required</div>
                </mat-error>
              </div>
              <div class="col-md-3">
                <mat-form-field [ngStyle]="{'margin-bottom': featureTypeSelect.invalid  && (featureTypeSelect.touched || this.isCopyClicked) ? '-0.8em':'0em'}">
                  <mat-label>Select Division</mat-label>
                  <mat-select name="selectedDivision" (selectionChange)="supportTopicTypeChangeByDivision($event);" required #featureTypeSelect="ngModel"
                    [(ngModel)]="selectedDivision">
                    <mat-option value='toyota'>Toyota</mat-option>
                    <mat-option value='lexus'>Lexus</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="featureTypeSelect.invalid  && (featureTypeSelect.touched || this.isCopyClicked)">
                  <div *ngIf="featureTypeSelect.errors.required">Support Topic Type is required</div>
                </mat-error>
              </div>
              <div class="col-md-3">
                <mat-form-field [ngStyle]="{'margin-bottom': featureNameSelect.invalid  && (featureNameSelect.touched || this.isCopyClicked) ? '-0.8em':'0em'}">
                  <mat-label>Existing Support Topic Name</mat-label>
                  <mat-select [disabled]="isViewMode" name="selectedFeature" [ngModelOptions]="{standalone: true}" (selectionChange)="featureSelectionChange($event);"
                    required #featureNameSelect="ngModel" [(ngModel)]="selectedFeature">
                    <mat-option *ngFor="let feature of features" [value]="feature.issueId">
                      {{feature.controls[0].featureName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="featureNameSelect.invalid  && (featureNameSelect.touched || this.isCopyClicked)">
                  <div *ngIf="featureNameSelect.errors.required">Support Topic Name is required</div>
                </mat-error>
              </div>

              <div class="col-md-3" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
                <mat-form-field class="example-full-width" [ngStyle]="{'margin-bottom': targetName.invalid  && (targetName.touched || this.isCopyClicked) ? '-0.8em':'0em'}">
                  <input [disabled]="isViewMode" matInput placeholder="Support Topic Name" required name="targetName" [(ngModel)]="targetFeatureName"
                    value="" #targetName="ngModel">
                </mat-form-field>
                <mat-error *ngIf="targetName.invalid && (targetName.touched || this.isCopyClicked)">
                  <div *ngIf="targetName.errors.required">Name is required</div>
                </mat-error>
              </div>
              <span class="save-btn copy-button mt-3">
                <button type="button" class="btn btn-default btn-copy" (click)="onCopyFeature($event)">
                  {{ "Copy" | translate}}</button>
              </span>
            </div>
          </div>
          <div *ngIf="selectedFeatureCreationType ==='New'" class="row mt-5">
            <div class="col-md-12 col-lg-12 d-flex">
              <span class="float-right ml-auto controls-right">
                <button id="edit-view" class="ml-2 btn btn-browse" [hidden]="isAddMode || isEditMode || adminService.addStepClicked" type="button"
                  (click)="previewFeature()">
                  {{ "Button.preview" | translate}}
                </button>

                <button *ngIf="featureInfo.status == 'draft'" id="edit-view" class="ml-2 btn btn-browse" [hidden]="isEditMode || isAddMode || adminService.addStepClicked"
                  type="button" (click)="editFeature(featureForm , featureInfo.issueId)">
                  <div *ngIf="featureInfo.status === 'draft'">
                    {{ "Button.edit" | translate}}
                  </div>
                </button>
                <button *ngIf="featureInfo.status == 'draft'" id="delete-view" class="ml-2 btn btn-browse" [hidden]="isAddMode || adminService.addStepClicked"
                  type="button" (click)="removeFeature();" [hidden]="adminService.addStepClicked">
                  {{ "Button.delete" | translate}}
                </button>
                <span class="save-btn ml-2">

                  <button type="button" type="submit" [hidden]="isViewMode" [hidden]="isViewMode" class="btn btn-default btn-save"> {{ "Button.save" | translate}}</button>
                </span>
                <span class="ml-2">
                  <button type="button" [hidden]="isViewMode" class="btn btn-secondary" (click)="openCancelDialog(featureForm);">
                    {{ "Button.cancel" | translate}}</button>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>